module.exports = __webpack_public_path__ + "img/search.6f0b9903.svg";